<script setup lang="ts">
import { computed } from 'vue'
import global from './global';

const proxy=global();

// 计算是否需要显示横屏提示
const showLandscapeTip = computed(() => {
  return proxy?.isMobileDevice?.value && !proxy?.isPortrait?.value
})

</script>

<template>
    <!-- 全局横屏提示层 -->
    <div v-if="showLandscapeTip" class="landscape-tip-overlay">
        <div class="landscape-tip-content">
            <div class="rotate-icon">📱</div>
            <p>请在竖屏下浏览以获得最佳体验</p>
        </div>
    </div>
    
    <router-view />
</template>
<style scoped>
/* 横屏提示样式 */
.landscape-tip-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.8);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
  flex-direction: column;
}

.landscape-tip-content {
  text-align: center;
  color: white;
  padding: 2rem;
}

.rotate-icon {
  font-size: 4rem;
  margin-bottom: 1rem;
  animation: rotate 3s infinite ease-in-out;
}

.landscape-tip-content p {
  font-size: 1.2rem;
  margin: 0;
}

@keyframes rotate {
  0%, 100% {
    transform: rotate(0deg);
  }
  50% {
    transform: rotate(90deg);
  }
}
</style>
